/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getStructDecoder,
  getStructEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';
import {
  getFeeRouteDecoder,
  getFeeRouteEncoder,
  type FeeRoute,
  type FeeRouteArgs,
} from '.';

export type FeeRoutingMatrix = { assetFees: FeeRoute; numeraireFees: FeeRoute };

export type FeeRoutingMatrixArgs = {
  assetFees: FeeRouteArgs;
  numeraireFees: FeeRouteArgs;
};

export function getFeeRoutingMatrixEncoder(): FixedSizeEncoder<FeeRoutingMatrixArgs> {
  return getStructEncoder([
    ['assetFees', getFeeRouteEncoder()],
    ['numeraireFees', getFeeRouteEncoder()],
  ]);
}

export function getFeeRoutingMatrixDecoder(): FixedSizeDecoder<FeeRoutingMatrix> {
  return getStructDecoder([
    ['assetFees', getFeeRouteDecoder()],
    ['numeraireFees', getFeeRouteDecoder()],
  ]);
}

export function getFeeRoutingMatrixCodec(): FixedSizeCodec<
  FeeRoutingMatrixArgs,
  FeeRoutingMatrix
> {
  return combineCodec(
    getFeeRoutingMatrixEncoder(),
    getFeeRoutingMatrixDecoder(),
  );
}
